// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"Xm-z","badgeLink":"Ym-z","category":"Zm-z"};